import { render, staticRenderFns } from "./FileRowTranslation.vue?vue&type=template&id=5cb82a5a&"
import script from "./FileRowTranslation.vue?vue&type=script&lang=js&"
export * from "./FileRowTranslation.vue?vue&type=script&lang=js&"
import style0 from "./FileRowTranslation.vue?vue&type=style&index=0&id=5cb82a5a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports